module.exports = __webpack_public_path__ + "img/googleSeo.adf83a3f.jpg";